import { createIcon } from '@chakra-ui/react';

export const TBankIcon = createIcon({
  displayName: 'TBankIcon',
  viewBox: '0 0 36 16',
  path: (
    <>
      <path
        d='M28.52 0.5H7.48C3.35 0.5 0 3.86 0 8C0 12.14 3.35 15.5 7.48 15.5H28.52C32.65 15.5 36 12.14 36 8C36 3.86 32.65 0.5 28.52 0.5Z'
        fill='#303030'
      ></path>
      <path
        d='M16.97 8.15003V6.93003H18.29C18.57 6.93003 18.73 6.96003 18.86 7.01003C19.09 7.10003 19.2 7.31003 19.2 7.54003C19.2 7.77003 19.07 8.01003 18.82 8.09003C18.7 8.13003 18.56 8.15003 18.29 8.15003H16.97ZM18.5 5.78003H15.51V10.56H16.96V9.27003H18.49C18.85 9.27003 19.2 9.27003 19.54 9.15003C20.2 8.94003 20.69 8.35003 20.69 7.55003C20.69 6.75003 20.21 6.16003 19.56 5.93003C19.2 5.80003 18.86 5.78003 18.49 5.78003H18.5Z'
        fill='white'
      ></path>
      <path
        d='M22.42 9.87003H24.62L24.9 10.56H26.53L24.58 5.78003H22.46L20.51 10.56H22.15L22.42 9.87003ZM22.78 8.81003L23.47 6.88003H23.58L24.27 8.81003H22.78Z'
        fill='white'
      ></path>
      <path
        d='M30.07 5.78003L28.89 7.96003H28.84L27.65 5.78003H25.96L28.11 9.29003V10.56H29.61V9.17003L31.66 5.78003H30.07Z'
        fill='white'
      ></path>
      <path
        d='M4.34007 4.36011H12.4101V8.43011C12.4101 9.47011 11.8501 10.4401 10.9501 10.9601L8.37008 12.4501L5.79008 10.9601C4.89008 10.4401 4.33008 9.47011 4.33008 8.43011V4.36011'
        fill='#FFDD2D'
      ></path>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M6.56006 6.5V7.77C6.73006 7.57 7.05006 7.44 7.41006 7.44H7.80006V8.91C7.80006 9.3 7.69006 9.64 7.54006 9.83H9.24006C9.08006 9.64 8.98006 9.3 8.98006 8.91V7.44H9.37006C9.73006 7.44 10.0401 7.57 10.2201 7.77V6.5H6.58006'
        fill='#333333'
      ></path>
    </>
  ),
});
